import { NgModule, Directive } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';

@Directive({
    selector: '[userMobileNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UserMobileNumberValidatorGeneric,
            multi: true
        }
    ],
    standalone: false
})
export class UserMobileNumberValidatorGeneric implements Validator {
    readonly pattern = /^0((5[0-8]{1})|(6[4-8]{1}))[0-9]{7}$/;

    protected _validate(input: string): boolean {
        let regx = new RegExp(this.pattern);
        return regx.test(input);
    }

    validate(control: AbstractControl): {[key: string]: any} {
        let input = control.value;
        let valid = input.length ? this._validate(input) : (input.length > 0);
        return valid ? null : {validator: {valid: false}};
    }

}

export function UserMobileNumberValidatorFn(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
        let r = new UserMobileNumberValidatorGeneric();
        return r.validate(control.value);
    };
}

@NgModule({
    declarations: [UserMobileNumberValidatorGeneric],
    exports: [UserMobileNumberValidatorGeneric]
})
export class UserMobileNumberValidatorModuleGeneric {}